import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTime)

export const fromNow = (input: string): string => {
   return dayjs(input).fromNow()
}

export const sleep = (ms: number) => new Promise(res => setTimeout(res, ms));